import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { refundSteps } from '../../data/content';
export function RefundSection() {
  return <section className="bg-sand py-16 md:py-[84px]" data-id="element-195" data-mp="34uforf6pkw96">
      <div className="mx-auto max-w-[1120px] px-5" data-id="element-196" data-mp="2zwxad99x9ots">
        <SectionHeading kicker="¿Y si no me gusta?" icon={AlertTriangle} title={<>
              Simple: <em data-id="element-198" data-mp="27806wcaddwl3">te devolvemos tu dinero</em>
            </>} lead="Sin trámites complicados ni letra chica. Así funciona:" data-id="element-197" data-mp="2zx714z2sk00j" />
        <ol className="mt-10 grid gap-[18px] md:grid-cols-3" data-id="element-199" data-mp="2lxo6n92wkn6p">
          {refundSteps.map((s, i) => <li key={s.title} data-id="element-200" data-mp="2h4lbiwih95oe" data-mpi={i}>
              <Reveal delay={i * 0.05} className="h-full rounded-[22px] bg-white p-[26px]" data-id="element-201" data-mp="2h4cv4un5bi8g">
                <span className="font-display text-[38px] font-extrabold leading-none text-tangerine" data-id="element-202" data-mp="1teio4tpicnw4">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-2.5 text-[19px] font-semibold text-forest" data-id="element-203" data-mp="22gz8zng915yj">{s.title}</h3>
                <p className="mt-1.5 break-words text-[15.5px] leading-relaxed text-muted" data-id="element-204" data-mp="27fai1vypzcfp">{s.text}</p>
              </Reveal>
            </li>)}
        </ol>
      </div>
    </section>;
}